import {
  BOND_PATH,
  MY_SHOP_PATH,
  SHOP_PRODUCTS_PATH,
  SHOP_PRODUCTS_PATH_A
} from '@constant'
import { isHonorable, isUltimate } from '@merchant-backend/util'
import { getMerchantInfo, getProTitle, isHotelMerchant } from '@util'
import _get from 'lodash/get'
import { observer } from 'mobx-react'
import moment from 'moment'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Icon from './Icon'
import styles from './style.module.less'

/** 旗舰版/尊享版 */
@observer
export default class extends Component {
  render() {
    const { pro_date } = getMerchantInfo()
    const endDate = (pro_date || '').split(' ')[0] || ''
    const diff = moment(pro_date).diff(moment(), 'days')
    const { hideLevelIcon, hideSafeShop } = this.props
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>当前服务</div>
        <div className={styles.tags}>
          <ProTypeIcon />
          {!hideLevelIcon && <GradeIcon />}
          {!hideSafeShop && <SafeShop />}
        </div>
        <div className={styles.endDate}>
          <span className={styles.type}>{getProTitle()}</span>
          {diff > 30 && (
            <span>
              将于 <span className={styles.date}>{endDate}</span> 到期
            </span>
          )}
          {diff <= 30 && (
            <span>
              剩余<span className={styles.date}>{diff + 1}</span>天可用
            </span>
          )}
        </div>
        {diff <= 30 && (
          <a className={styles.btn} href={SHOP_PRODUCTS_PATH_A}>
            立即续费
          </a>
        )}
      </div>
    )
  }
}

/** 旗舰版/尊享版等图标 */
function ProTypeIcon() {
  let icon = '//qnm.hunliji.com/FlPSOQ0m8Kh5AxXjNpvTqCSj9Xmz'
  let text = getProTitle()
  let style = {
    borderColor: '#c2c2c2',
    backgroundColor: '#c2c2c2',
    color: '#ffffff'
  }

  if (isUltimate() || isHonorable()) {
    icon = '//qnm.hunliji.com/Fu4DDL0zu1_h5ZaFM5aocHLLleGk'
    style = {
      borderColor: '#323232',
      backgroundColor: '#323232',
      color: '#DBC49D'
    }
  }

  return (
    <Link to={SHOP_PRODUCTS_PATH}>
      <Icon icon={icon} text={text} style={style} />
    </Link>
  )
}

/** 商家等级 金牌，银牌.. */
function GradeIcon() {
  const grade_level = _get(getMerchantInfo(), 'grade.grade_level', 0)
  let icon = ''
  let text = ''
  let borderColor = ''
  let backgroundColor = ''
  let color = ''

  switch (grade_level) {
    case 0:
      icon = '//qnm.hunliji.com/FtyfMSfA_sQ_JKSMIiol-DgtlZkO'
      text = '普通商家'
      borderColor = '#B2B2B2'
      backgroundColor = '#C2C2C2'
      color = '#FFFFFF'
      break
    case 2:
      icon = '//qnm.hunliji.com/Fh5B5lNqVHEOSk2-8oJdNebb-6Og'
      text = '银牌商家'
      borderColor = '#BEDEFB'
      backgroundColor = '#D9F2FF'
      color = '#56A2E8'
      break
    case 3:
      icon = '//qnm.hunliji.com/FsdYzAHxV6FbVJ_T7uwXc-2kHlOt'
      text = '金牌商家'
      borderColor = '#FCCD7F'
      backgroundColor = '#FEEAA9'
      color = '#F17947'
      break
    case 4:
      icon = '//qnm.hunliji.com/FlanRFi8Mf7lD-OpxNajpDa7sck4'
      text = '钻石商家'
      borderColor = '#DDB6FF'
      backgroundColor = '#F0E0FF'
      color = '#BA80F0'
      break

    default:
      break
  }

  return (
    icon && (
      <Link to={MY_SHOP_PATH}>
        <Icon
          icon={icon}
          text={text}
          style={{
            borderColor,
            backgroundColor,
            color,
            marginLeft: 8
          }}
        />
      </Link>
    )
  )
}

/** 放心购 */
function SafeShop() {
  let icon = '//qnm.hunliji.com/FjJFzI1AoGNXn1O7Eeyk1lM0DNhq'
  let text = '放心购'
  let style = {
    borderColor: '#B2B2B2',
    backgroundColor: '#ffffff',
    color: '#B2B2B2'
  }

  if (getMerchantInfo().is_bond) {
    icon = '//qnm.hunliji.com/Fqdo6gPlIq8o-nL6YRqhNFMI2svV'
    style = {
      borderColor: '#80D088',
      backgroundColor: '#77C682',
      color: '#ffffff'
    }
  }

  return (
    !isHotelMerchant() && (
      <Link to={BOND_PATH}>
        <Icon icon={icon} text={text} style={{ ...style, marginLeft: 8 }} />
      </Link>
    )
  )
}
